/**
 * @import { RouteFeature } from '../types/route-feature'
 */

import { useMap } from '@vis.gl/react-google-maps';
import { useMemo } from 'react';
import { usePolyline } from '../hooks/use-polyline';
import { zIndex } from '@/features/itinerary-map/utils/layer';

const lineColor = '#b10a32';

/**
 * @param {object} props
 * @param {RouteFeature} props.feature
 * @returns {React.JSX.Element}
 */
export function ExamplePolyline({ feature }) {
  const map = useMap();
  const polylineOptions = useMemo(() => {
    if (!map) {
      return {};
    }

    return /** @type {google.maps.PolylineOptions} */ ({
      zIndex: zIndex.examplePath,
      strokeColor: lineColor,
      strokeOpacity: 0,
      icons: [
        {
          icon: /** @type {google.maps.Symbol} */ ({
            path: 'M 0, -1 0, 1',
            scale: 4,
            strokeColor: lineColor,
            strokeOpacity: 1,
          }),
          offset: '0',
          repeat: '15px',
        },
      ],
      clickable: false,
    });
  }, [map]);

  usePolyline(feature, polylineOptions);
  return <></>;
}
